import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { HandoverSnapshotSignResponse } from "../v1/HandoverSnapshotSignResponse";
import { MrfiktivCreateSignDtoGen, MrfiktivPopulatedSnapshotSignRequestViewModelGen } from "../v1/data-contracts";

/**
 * Communicate with Snapshot Sign Response API
 */
class SnapshotSignResponseService {
  private mrfiktivProxy: HandoverSnapshotSignResponse;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new HandoverSnapshotSignResponse(mrfiktivHttpClientProvider.client());
  }

  /**
   * Gets a snapshot by shared access signature (SCT)
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    signRequestId: string,
    sct: string
  ): Promise<MrfiktivPopulatedSnapshotSignRequestViewModelGen> {
    const shared = await this.mrfiktivProxy.snapshotSignResponseControllerGet({
      partnerId,
      signRequestId,
      sct
    });

    return shared.data;
  }

  /**
   * Accepts a snapshot sign request using SCT
   */
  async respondAccept(
    partnerId: string,
    signRequestId: string,
    sct: string,
    data: MrfiktivCreateSignDtoGen
  ): Promise<MrfiktivPopulatedSnapshotSignRequestViewModelGen> {
    const res = await this.mrfiktivProxy.snapshotSignResponseControllerAccept({ partnerId, signRequestId, sct }, data);

    return res.data;
  }

  /**
   * Rejects a snapshot sign request using SCT
   */
  async respondReject(
    partnerId: string,
    signRequestId: string,
    sct: string
  ): Promise<MrfiktivPopulatedSnapshotSignRequestViewModelGen> {
    const res = await this.mrfiktivProxy.snapshotSignResponseControllerReject({
      partnerId,
      signRequestId,
      sct
    });

    return res.data;
  }
}

/**
 * Communicate with Snapshot Sign Response API
 */
export default new SnapshotSignResponseService(new MrfiktivHttpClientProvider());
